import { VectorMap } from "react-jvectormap";

export default VectorMap;
